// extracted by mini-css-extract-plugin
export default {"date":"input-tanggal_date__Hbg0R"};